import { render } from "./Budget.vue?vue&type=template&id=66688c22"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Budget/Budget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66688c22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66688c22', __exports__)) {
    api.reload('66688c22', __exports__)
  }
  
  module.hot.accept("./Budget.vue?vue&type=template&id=66688c22", () => {
    api.rerender('66688c22', render)
  })

}


export default __exports__